var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "management",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 25,
    height: 25,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "id-card",
    transform: "translate(2 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M37.5,1.681H33.746a2.421,2.421,0,0,0-4.61,0H25.417A1.417,1.417,0,0,0,24,3.1V15.119a1.417,1.417,0,0,0,1.417,1.417H37.5a1.417,1.417,0,0,0,1.417-1.417V3.1A1.417,1.417,0,0,0,37.5,1.681Zm-6.058-.1a.844.844,0,1,1-.844.844A.844.844,0,0,1,31.441,1.576Zm4.208,12.17a.474.474,0,0,1-.472.472H27.746a.474.474,0,0,1-.472-.472v-.219a1.83,1.83,0,0,1,.732-1.468,13.927,13.927,0,0,1,2.025-1.239.078.078,0,0,0,.044-.067V9.939a1.969,1.969,0,0,1-.24-.651c-.091-.007-.213-.135-.341-.591-.175-.624.01-.715.169-.7a1.519,1.519,0,0,1-.068-.256h0a1.834,1.834,0,0,1,0-.823,1.78,1.78,0,0,1,.479-.84,2.21,2.21,0,0,1,.445-.368,1.744,1.744,0,0,1,.432-.223h0a1.464,1.464,0,0,1,.391-.074,1.613,1.613,0,0,1,.985.209,1.225,1.225,0,0,1,.479.445s.8.057.526,1.674a1.8,1.8,0,0,1-.067.256c.159-.013.348.078.169.7-.128.456-.25.584-.341.591a1.8,1.8,0,0,1-.24.645v.82a.07.07,0,0,0,.044.067,13.926,13.926,0,0,1,2.025,1.239,1.83,1.83,0,0,1,.732,1.468v.219Z",
    transform: "translate(-21 4)",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.c0381f66401fae0e746e6c9140116314.svg";
export { ForwardRef as ReactComponent };